module.exports = {"name":"hideSidebar","audiences":["allMembers"],"experimentAllocation":1,"defaultWeight":1,"experimentVersion":"v1","autoTrack":true,"defaults":{"enabled":false},"variations":[{"name":"shouldHide","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/hideSidebar.json
// module id = XtV5
// module chunks = 2